<div *ngIf="msg" class="alert alert-success">{{msg}}</div>
<div *ngIf="error" class="alert alert-danger">{{error}}</div>

